import IconCheckmark from 'assets/icons/checkmark.svg';
import Container from 'components/container';
import FunnelCta from 'components/funnel/cta';
import Image from 'next/legacy/image';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FUNNEL_STEPS } from '../constants';
import { useSubscriptionFunnel } from '../state';

const StepStart: React.FC = () => {
  const { goToStep } = useSubscriptionFunnel();

  return (
    <div
      className="bg-other-white w-full lg:max-w-2xl lg:rounded-lg lg:shadow-lg"
      data-test="subscription-funnel-start"
    >
      <Image
        src="/images/futterabo/PetsDeli_FutterAbo_Intro_1344x880px.jpeg"
        width={1344}
        height={880}
        layout="responsive"
        className="lg:rounded-t-lg"
      />
      <Container>
        <h1 className="text-primary-main text-xl leading-6 font-medium lg:pt-4 lg:text-center lg:text-4xl lg:leading-10 lg:font-black">
          <FormattedMessage id="subscription-funnel:start:header" />
        </h1>

        <ul className="text-text-light-bg-secondary mt-4">
          <li className="mt-2 flex items-center">
            <div className="bg-primary-main text-text-dark-bg-contrast-white mr-3 flex h-6 w-6 shrink-0 items-center justify-center rounded-full font-medium">
              <IconCheckmark className="h-3 w-3" />
            </div>
            <FormattedMessage id="subscription-funnel:start:list:item-1" />
          </li>
          <li className="mt-2 flex items-center">
            <div className="bg-primary-main text-text-dark-bg-contrast-white mr-3 flex h-6 w-6 shrink-0 items-center justify-center rounded-full font-medium">
              <IconCheckmark className="h-3 w-3" />
            </div>
            <FormattedMessage id="subscription-funnel:start:list:item-2" />
          </li>
          <li className="mt-2 flex items-center">
            <div className="bg-primary-main text-text-dark-bg-contrast-white mr-3 flex h-6 w-6 shrink-0 items-center justify-center rounded-full font-medium">
              <IconCheckmark className="h-3 w-3" />
            </div>
            <FormattedMessage id="subscription-funnel:start:list:item-3" />
          </li>
        </ul>

        <FunnelCta
          visible
          onClick={() => {
            goToStep(FUNNEL_STEPS.PREFERENCE);
          }}
          data-test="subscription-funnel-button-configure"
        >
          <FormattedMessage id="subscription-funnel:start:button-configure" />
        </FunnelCta>
      </Container>
    </div>
  );
};

export default StepStart;
